import { useTranslation } from 'react-i18next'

function ErrorPage() {
  const { t } = useTranslation()

  return (
    <div className="grid h-screen w-full place-items-center font-roobert">
      <div className="flex flex-col content-center items-center">
        <h1 className="font-tusker text-center text-7xl font-extrabold">
          {t('error_page.title')}
        </h1>
        <h4 className="mt-8 text-3xl font-extrabold">
          {t('error_page.subtitle')}
        </h4>
        <div className="pt-4">
          <p className="text-center [text-wrap:balance]">
            {t('error_page.contact_us')}
          </p>
        </div>
      </div>
    </div>
  )
}
export default ErrorPage
